/**
 * System ROLES and User Roles Operations
 */

import { AUTHORITIES } from 'app/config/constants';
import { CompanyType } from '../model/enumerations/company-type.model';

/**
 * Options to choose between roles
 */
export const userRoles = ['Administrador', 'Motorista', 'Visualizador', 'Checklist'];

/**
 * Translate userRoles to System ROLES
 * @param companyType Type (OWNER, TRANSPORTER, MANUFACTURER)
 * @param authorities userRoles options
 * @return Array with System ROLES
 */
export const translateUserRole = (companyType, authorities) => {
  if (companyType === CompanyType.MANUFACTURER) {
    if (authorities === 'Administrador') return [AUTHORITIES.MANUFACTURER_ADMIN, AUTHORITIES.USER];

    if (authorities === 'Motorista') return [AUTHORITIES.DRIVER, AUTHORITIES.USER];

    if (authorities === 'Checklist') return [AUTHORITIES.CHECKLIST, AUTHORITIES.USER];

    return [AUTHORITIES.USER];
  }

  if (companyType === CompanyType.TRANSPORTER) {
    if (authorities === 'Administrador') return [AUTHORITIES.TRANSPORTER_ADMIN, AUTHORITIES.USER];

    if (authorities === 'Motorista') return [AUTHORITIES.DRIVER, AUTHORITIES.USER];

    if (authorities === 'Checklist') return [AUTHORITIES.CHECKLIST, AUTHORITIES.USER];

    return [AUTHORITIES.USER];
  }

  if (companyType === CompanyType.OWNER) {
    if (authorities === 'Administrador') return [AUTHORITIES.ADMIN, AUTHORITIES.USER];

    if (authorities === 'Motorista') return [AUTHORITIES.DRIVER, AUTHORITIES.USER];

    if (authorities === 'Manutenção') return [AUTHORITIES.MAINTENANCE, AUTHORITIES.USER];

    return [AUTHORITIES.USER];
  }

  if (companyType === CompanyType.REPRESENTATIVE) {
    if (authorities === 'Administrador') return [AUTHORITIES.REPRESENTATIVE_ADMIN, AUTHORITIES.USER];

    return [AUTHORITIES.USER];
  } else return [];
};

/**
 * Translate System ROLES to userRoles
 * @param role Array with System ROLES
 * @return userRoles options
 */
export const translateSystemRole = role => {
  if (!role) {
    return '';
  }

  if (role && !role.length) {
    return '';
  }

  if (
    role.includes(AUTHORITIES.ADMIN) ||
    role.includes(AUTHORITIES.MANUFACTURER_ADMIN) ||
    role.includes(AUTHORITIES.TRANSPORTER_ADMIN) ||
    role.includes(AUTHORITIES.REPRESENTATIVE_ADMIN)
  ) {
    return 'Administrador';
  }

  if (role.includes(AUTHORITIES.DRIVER)) {
    return 'Motorista';
  }

  if (role.includes(AUTHORITIES.MAINTENANCE)) {
    return 'Manutenção';
  }

  if (role.includes(AUTHORITIES.CHECKLIST)) {
    return 'Checklist';
  }

  if (role.includes(AUTHORITIES.USER)) {
    return 'Visualizador';
  }

  return '';
};

export const isAdminByCompanyType = (companyType: CompanyType) => {
  if (companyType === CompanyType.OWNER) {
    return true;
  }
  return false;
};
